<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
<!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/persona">Personas</router-link>
<!--			
            <router-link to="/medico">Médicos</router-link>
-->			
          </div>
        </div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;"
            @click="showModalHelp = true">help
          </span>
        </div>
      </div>
    </div>

    <Modal v-model:modelValue="showModalHelp">
      <AyudaMedioPersForm />
    </Modal>

    <hr>

<!-- Master: Datos Persona -->
    <div class="modal-dialog modal-xl" style="z-index: 1;">
      <div class="modal-content">
        <div class="d-flex justify-content-between align-items-center">
          <b>Datos Persona</b>
          <button
            class="btn btn-link p-0 text-decoration-none"
            @click.prevent="mostrarBloque = !mostrarBloque"
          >
            <span class="material-symbols-outlined align-middle">
              {{ mostrarBloque ? 'expand_less' : 'expand_more' }}
            </span>
            {{ mostrarBloque ? 'Mostrar menos' : 'Mostrar más' }}
          </button>
        </div>
        <div v-if="mostrarBloque">
          <form>
            <div class="modal-body">
              <div class="mb-3">
                <div class="row">
                  <div class="col-1">
                    <label for="documento" class="form-label">Documento</label>
                  </div>
                  <div class="col-1">
                    {{ datoPersona.documento }}
                  </div>
                  <div class="col-1">
                  </div>
                  <div class="col-1">
                    <label class="form-label">Nombre</label>
                  </div>
                  <div class="col-8">
                    {{ datoPersona.primerNombre }}
                    {{ datoPersona.segundoNombre }}
                    {{ datoPersona.primerApellido }}
                    {{ datoPersona.segundoApellido }}
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="telefono" class="form-label">Teléfono</label>
                  </div>
                  <div class="col-4">
                    {{ datoPersona.telefono }}
                  </div>
                  <div class="col-2">
                    <label for="email" class="form-label">Email</label>
                  </div>
                  <div class="col-4">
                    {{ datoPersona.email }}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

<!-- Estructura de Tabs -->
    <div class="tab-bar mt-3">
      <button class="tablink" @click="showTable = 'medios'"
        :class="{ 'active-tab': showTable === 'medios' }">
        <span class="material-symbols-outlined">phone_in_talk</span>
        Medios de Comunicación
      </button>
    </div>

<!-- Detail: Medios de Comunicación -->
    <div v-if="showTable === 'medios'">
      <DataTable
        :data="medioperss"
        :columns="columnasMedios"
        idField="idMedioPers"
        :mostrarInfo="false"
        :mostrarVer="false"
        :mostrarEditar="true"
        :mostrarEliminar="true"
        accionesWidth="80px"
        @refresh="getMedioPerss"
        @create="abrirModalCrear"
        @edit="row => abrirModalEditar(row.idMedioPers)"
        @delete="row => deleteMedioPers(row.idMedioPers)"
      />
    </div>

<!-- Modal Detalle: Medio de Comunicación -->
    <div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo_det }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar_det">
                <div class="row">
                  <div class="col-2">
                    <label for="idMedioPers" class="form-label">IdMedioPers</label>
                  </div>
                  <div class="col-10">
                    <input type="text" class="form-control" id="idMedioPers" name="idMedioPers"
                      v-model="datoMedioPers.idMedioPers" disabled>
                  </div>
                </div>
              </div>
<div class="mb-3">
  <div class="row">
    <div class="col-2">
      <label for="idMedioCom" class="form-label">Medio Com.</label>
    </div>
    <div class="col-10">
      <select
        class="form-select"
        id="idMedioCom"
        name="idMedioCom"
        v-model="datoMedioPers.idMedioCom"
        required
      >
        <option value="" disabled>Seleccione un medio de comunicación</option>
        <option
          v-for="medio in medioComs"
          :key="medio.idMedioCom"
          :value="medio.idMedioCom"
        >
          {{ medio.nombre }}
        </option>
      </select>
    </div>
  </div>
</div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="descripcion" class="form-label">Descripción</label>
                  </div>
                  <div class="col-10">
                    <input type="text" class="form-control" id="descripcion" name="descripcion"
                      v-model="datoMedioPers.descripcion" required>
                  </div>
                </div>
              </div>
              <div v-if="datoMedioPers.idMedioPers" class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaReg" class="form-label">FechaReg</label>
                  </div>
                  <div class="col-10">				  
                    <label for="fechaReg" class="form-label">{{ getFormattedDate(datoMedioPers.fechaReg) }}</label>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button type="submit" class="btn btn-light" @click.prevent="guardarMedioPers" v-if="btnCrear_det" title="Guardar">
              <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
            </button>
            <button type="submit" class="btn btn-light" @click.prevent="guardarEditMedioPers" v-if="btnEditar_det" title="Actualizar">
              <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />

  </div>

</template>

<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import AyudaMedioPersForm from '@/views/ayuda/AyudaMedioPersForm.vue';

import dateFormat from '@/modules/dateFormat.js';
import DataTable from '@/components/DataTable.vue';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from 'sweetalert'

export default {
  props: {
    p_idPersona: { type: Number, required: true },
  },
  components: {
    Layout,
    Footer,
    DataTable,
    AyudaMedioPersForm,
  },
  data() {
    return {
      // Variables master
      personas: [],
      datoPersona: {},
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      mostrarBloque: true,
      showTable: 'medios',
      showModalHelp: false,
      // Variables details
      medioperss: [],
      datoMedioPers: {},
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      modalWindow: true,
      // Columnas DataTable
      columnasMedios: [
        { field: 'idMedioPers',   label: 'Id',                numeric: true },
        { field: 'idPersona',     label: 'Persona',           numeric: true },
        { field: 'medioComNombre',label: 'Medio de Com.',     filterType: 'text' },
        { field: 'descripcion',   label: 'Descripción',       filterType: 'text' },
        { field: 'fechaReg',      label: 'Fecha Reg.',        date: true,
          format: v => dateFormat.getFormattedDate(v) },
        { field: 'estado',        label: 'Estado',            filterType: 'select',
          filterOptions: ['A', 'I'] },
      ],
      medioComs: [],
    }
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.abrirEditar(this.p_idPersona)
    this.getMedioPerss()
    this.getMedioComs()
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    validarFormDetalle() {
      const fields = ['idMedioCom','descripcion']
      return validarForm(this.datoMedioPers, fields, fields)
    },
    abrirCrear() {
      this.datoPersona = {};
      this.titulo = 'Crear';
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirEditar(idPersona) {
      if (idPersona != null) {
        api.get('/vwpersonas/' + idPersona).then(resp => {
          this.datoPersona = resp.data;
        });
      }
      this.titulo = 'Editar';
      this.btnCrear = false;
      this.btnEditar = true;
    },

    async getMedioPerss() {
      const resp = await api.get('/vwmedioperss/idpersona/'+this.p_idPersona);
      this.medioperss = resp.data;
    },
    async guardarMedioPers() {
      if (this.validarFormDetalle() === 1) {
        try {
          this.datoMedioPers.idPersona = this.datoPersona.idPersona;
          await api.post('/medioperss', this.datoMedioPers);
          await this.getMedioPerss();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Medio de comunicación creado exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Inténtelo de nuevo!", "error");
        }
      }
    },
    async guardarEditMedioPers() {
      if (this.validarFormDetalle() === 1) {
        try {
          await api.post('/medioperss', this.datoMedioPers);
          await this.getMedioPerss();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Medio de comunicación actualizado exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Inténtelo de nuevo!", "error");
          const array = Object.values(error.response.data.errors);
          array.forEach(element => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.datoMedioPers = {};
      this.titulo_det = 'Crear Medio de Comunicación';
      this.btnCrear_det = true;
      this.btnEditar_det = false;
      $('#ventanaModal').modal('show');
    },
    abrirModalEditar(idMedioPers) {
      if (idMedioPers != null) {
        api.get('/vwmedioperss/' + idMedioPers).then(resp => {
          this.datoMedioPers = resp.data;
        });
      }
      $('#ventanaModal').modal('show');
      this.titulo_det = 'Editar Medio de Comunicación';
      this.btnCrear_det = false;
      this.btnEditar_det = true;
    },
    async deleteMedioPers(idMedioPers) {
      try {
        await api.delete('/medioperss/' + idMedioPers);
        await this.getMedioPerss();
      } catch (error) {
        swal("Error!", "No se pudo eliminar el registro.", "error");
      }
    },
    async getMedioComs() {
      const resp = await api.get('/vwmediocoms');
      this.medioComs = resp.data.filter(m => m.estado === 1);
    },

  },
}
</script>

<style scoped>
.tab-bar {
  display: flex;
  align-items: stretch;
  gap: 4px;
  border-bottom: 2px solid #dee2e6;
  background: #f8f9fa;
  border-radius: 8px 8px 0 0;
  padding: 6px 8px 0;
  flex-wrap: wrap;
}
.tablink {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 12px 8px;
  border: 1px solid transparent;
  border-bottom: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  color: #6c757d;
  border-radius: 6px 6px 0 0;
  white-space: nowrap;
  transition: background .15s, color .15s;
}
.tablink:hover { background: #e9ecef; color: #343a40; }
.active-tab {
  background: #fff;
  color: #0d6efd;
  border-color: #dee2e6;
  font-weight: 500;
  margin-bottom: -2px;
  border-bottom: 2px solid #fff;
}
</style>